import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { useSerpsMatch } from '@xing-com/crate-jobs-domain-serps-hooks';

export const useSearchConsumer = (): string => {
  const { isLoggedIn } = useLoginState();
  const serps = useSerpsMatch();

  if (isLoggedIn) {
    return 'loggedin.web.jobs.conv_search_results.center';
  }

  if (serps) {
    return 'loggedout.web.jobs.seo_search_results.center';
  }

  return 'loggedout.web.jobs.conv_search_results.center';
};
